// GENERATED by ds/tokens/build.mjs — do not edit

export interface SkinMeta {
  name: string; label: string; era: string
  colorScheme: 'light' | 'dark'
  default: boolean; hidden: boolean; description: string
}

export const skins: readonly SkinMeta[] = [
  {
    name: 'galenti',
    label: 'Galenti',
    era: 'own-brand',
    colorScheme: 'light',
    default: true,
    hidden: false,
    description: 'Bone & air — the own-brand default. Warm bone ground, huge Hanken settings, terracotta micro-accent, dark islands.',
  },
  {
    name: 'agentic',
    label: 'Agentic era',
    era: '2024',
    colorScheme: 'dark',
    default: false,
    hidden: false,
    description: 'The kiln as identity — night surfaces, ember glow, mono headings. The era that built the engine wears its own dark.',
  },
  {
    name: 'debug',
    label: 'Debug',
    era: 'torture-test',
    colorScheme: 'dark',
    default: false,
    hidden: true,
    description: 'Garish dark torture test. If a surface ignores the token engine, it shows here. Not a design — a diagnostic.',
  },
  {
    name: 'rails-era',
    label: 'Rails era',
    era: '2014',
    colorScheme: 'light',
    default: false,
    hidden: false,
    description: '2014 product web — flat and dense. Gray chrome, Bootstrap blue, hard corners, Helvetica-era type at 14px, jQuery easing.',
  },
  {
    name: 'react-era',
    label: 'React era',
    era: '2018',
    colorScheme: 'light',
    default: false,
    hidden: false,
    description: '2018 product web — bold flat Material. Paper-white surfaces, saturated primary blue, dp-elevation shadows, Roboto everywhere, standard-curve motion.',
  },
]

export const skinNames = ['galenti', 'agentic', 'debug', 'rails-era', 'react-era'] as const
export type SkinName = (typeof skinNames)[number]
export const defaultSkin: SkinMeta = skins.find((s) => s.default)!

export const semanticTokens: Record<
  'color' | 'radius' | 'type' | 'density' | 'motion' | 'shadow',
  readonly string[]
> = {
  color: ['--color-surface', '--color-surface-raised', '--color-surface-sunken', '--color-surface-overlay', '--color-ink', '--color-ink-muted', '--color-ink-faint', '--color-accent', '--color-accent-ink', '--color-accent-muted', '--color-line', '--color-line-strong', '--color-focus', '--color-positive', '--color-positive-surface', '--color-caution', '--color-caution-surface', '--color-critical', '--color-critical-surface', '--color-glow-ink'],
  radius: ['--radius-control', '--radius-surface', '--radius-pill'],
  type: ['--type-hero-family', '--type-hero-size', '--type-hero-weight', '--type-hero-line', '--type-hero-tracking', '--type-numeral-family', '--type-numeral-size', '--type-numeral-weight', '--type-numeral-line', '--type-numeral-tracking', '--type-display-family', '--type-display-size', '--type-display-weight', '--type-display-line', '--type-display-tracking', '--type-heading-family', '--type-heading-size', '--type-heading-weight', '--type-heading-line', '--type-heading-tracking', '--type-title-family', '--type-title-size', '--type-title-weight', '--type-title-line', '--type-title-tracking', '--type-body-family', '--type-body-size', '--type-body-weight', '--type-body-line', '--type-body-tracking', '--type-small-family', '--type-small-size', '--type-small-weight', '--type-small-line', '--type-small-tracking', '--type-mono-family', '--type-mono-size', '--type-mono-weight', '--type-mono-line', '--type-mono-tracking', '--type-statement-family', '--type-statement-size', '--type-statement-weight', '--type-statement-line', '--type-statement-tracking', '--type-intertitle-family', '--type-intertitle-size', '--type-intertitle-weight', '--type-intertitle-line', '--type-intertitle-tracking'],
  density: ['--density-row', '--density-control', '--density-control-sm', '--density-gap', '--density-pad'],
  motion: ['--motion-duration-xs', '--motion-duration-sm', '--motion-duration-md', '--motion-duration-lg', '--motion-duration-xl', '--motion-duration-2xl', '--motion-ease-enter', '--motion-ease-exit', '--motion-ease-move', '--motion-ease-drama', '--motion-ease-spring'],
  shadow: ['--shadow-raised', '--shadow-overlay', '--shadow-glow-accent', '--shadow-glow-soft'],
}

export const zoneNames = ['night', 'day'] as const
export type ZoneName = (typeof zoneNames)[number]
export const zoneTokens: Record<ZoneName, readonly string[]> = {
  'night': ['--color-surface', '--color-surface-raised', '--color-surface-sunken', '--color-surface-overlay', '--color-ink', '--color-ink-muted', '--color-ink-faint', '--color-accent', '--color-accent-ink', '--color-accent-muted', '--color-line', '--color-line-strong', '--color-focus', '--color-positive', '--color-positive-surface', '--color-caution', '--color-caution-surface', '--color-critical', '--color-critical-surface', '--color-glow-ink', '--shadow-raised', '--shadow-overlay', '--shadow-glow-accent', '--shadow-glow-soft'],
  'day': ['--color-surface', '--color-surface-raised', '--color-surface-sunken', '--color-surface-overlay', '--color-ink', '--color-ink-muted', '--color-ink-faint', '--color-accent', '--color-accent-ink', '--color-accent-muted', '--color-line', '--color-line-strong', '--color-focus', '--color-positive', '--color-positive-surface', '--color-caution', '--color-caution-surface', '--color-critical', '--color-critical-surface', '--color-glow-ink', '--shadow-raised', '--shadow-overlay', '--shadow-glow-accent', '--shadow-glow-soft'],
}

export const baseTokens: Record<'space' | 'z', readonly string[]> = {
  space: ['--space-0', '--space-1', '--space-2', '--space-3', '--space-4', '--space-5', '--space-6', '--space-7', '--space-8', '--space-9', '--space-10'],
  z: ['--z-base', '--z-raised', '--z-nav', '--z-overlay', '--z-palette', '--z-toast', '--z-skip'],
}

export const breakpoints: Record<string, string> = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
}

export const SKIN_STORAGE_KEY = 'portfolio:skin'
export const MOTION_STORAGE_KEY = 'portfolio:motion'
